'use strict';

angular.module('utils').factory('OCModalUtil', function(
  $modal,
  OCLogUtil,
) {

  const createResolve = (args) => Object.entries(args)
    .reduce((acc, [key, val]) => ({
      ...acc,
      [key]: function() {
        return val;
      },
    }), {});

  const modals = {

    error: (errorText) => ({
      templateUrl: '/views/modals/_error-message.html',
      controller: 'ModalErrorMessage',
      resolve: createResolve({
        errorText,
      }),
    }),

    confirm: (confirmText) => ({
      templateUrl: '/views/modals/_confirm-message.html',
      controller: 'ModalConfirmMessage',
      resolve: createResolve({
        confirmText,
      }),
    }),

    genericYesNo: (content) => ({
      templateUrl: '/views/modals/_generic-yes-no.html',
      controller: 'ModalGenericYesNo',
      resolve: createResolve({
        content: {
          title: null,
          body: null,
          btnYes: null,
          btnNo: null,
          className: null,
          ...content,
        },
      }),
    }),

    claimAwardGuide: ({ clinic, awardPlacementType }) => ({
      windowClass: 'modal-clinic-award-guide',
      templateUrl: '/views/modals/_clinic-award-guide.html',
      controller: 'ModalClinicAwardGuideCtrl',
      resolve: {
        ...createResolve({
          clinic,
          awardPlacementType: parseInt(awardPlacementType, 10) || null,
        }),
        award: function(ClinicService) {
          return ClinicService.getClinicAward(clinic.id);
        },
      },
    }),

    clinicAwardItEmail: ({ clinic, sender, recepient, codeSnippet }) => ({
      windowClass: 'modal-clinic-award-it-email',
      templateUrl: '/views/modals/_clinic-award-it-email.html',
      controller: 'ModalGenericYesNo',
      resolve: createResolve({
        content: {
          clinic,
          sender,
          recepient,
          codeSnippet,
          year: moment().year(),
        },
      }),
    }),

    clinicAwardVerify: ({ clinic, user, enableGuideOnFail }) => ({
      windowClass: 'modal-clinic-award-verify',
      templateUrl: '/views/modals/_clinic-award-verify.html',
      controller: 'ModalClinicAwardVerifyCtrl',
      resolve: {
        ...createResolve({
          clinic,
          enableGuideOnFail,
        }),
        user: function(CurrentUser) {
          return user || CurrentUser.getUser();
        },
      },
    }),

    clinicInstantBookUpdate: (clinic) => ({
      templateUrl: '/views/modals/_clinic-update-instant-book-modal.html',
      controller: 'ModalClinicInstantBookUpdate',
      resolve: createResolve({
        clinic,
      }),
    }),

    clinicInstantBookOutreach: ({ clinic, canClose }) => ({
      windowClass: 'modal-fullscreen',
      templateUrl: '/views/modals/_clinic-instant-book-outreach-modal.html',
      controller: 'ModalClinicInstantBookOutreach',
      resolve: createResolve({
        clinic,
        canClose,
      }),
    }),

    clinicInsuranceUpdate: ({ appointment, inNetwork }) => ({
      templateUrl: '/views/modals/_clinic-update-insurance-modal.html',
      controller: 'ModalClinicUpdateInsurance',
      resolve: createResolve({
        appointment,
        inNetwork,
      }),
    }),

    clinicPhoneVerify: ({ clinic, modalType }) => ({
      windowClass: 'modal-clinic-phone-verify',
      templateUrl: '/views/modals/_clinic-phone-verify.html',
      controller: 'ModalClinicPhoneVerifyCtrl',
      resolve: createResolve({
        clinic,
        modalType,
      }),
    }),

    clinicOCProOptIn: ({ clinic, reloadIframe }) => ({
      windowClass: 'modal oc-pro-opt-in-modal fade in',
      templateUrl: '/views/modals/_oc-pro-opt-in.html',
      controller: 'ModalOCProOptInCtrl',
      resolve: createResolve({
        clinic,
        reloadIframe,
      }),
    }),

    billingContested: ({
      appointment,
      refreshAppointments,
    }) => ({
      windowClass: 'billing-contested',
      templateUrl: '/views/modals/_billing-contested.html',
      controller: 'BillingContested',
      resolve: createResolve({
        appointment,
        refreshAppointments,
      }),
    }),

    practiceManagementSoftware: (clinic) => ({
      windowClass: 'modal-practice-management-software',
      templateUrl: '/views/modals/_practice-management-software.html',
      controller: 'ModalPracticeManagementSoftwareCtrl',
      backdrop: 'static',
      resolve: createResolve({
        clinic,
      }),
    }),

    bulkMessaging: (clinic) => ({
      windowClass: 'bulk-modal',
      templateUrl: '/views/modals/_bulk-messaging-modal.html',
      controller: 'BulkMessagingModalCtrl',
      resolve: {
        ...createResolve({
          clinic,
        }),
        requestedAppointments: function(AppointmentService) {
          return AppointmentService.listAppointmentsForOrganizer(
            'clinic',
            clinic.id,
            'requested',
            1,
            200,
          ).then(function(response) {
            return _.map(response.appointments, function(appointment) {
              return appointment.id;
            });
          });
        },
      },
    }),

    bulkMessagingSuccess: ({ status }) => ({
      windowClass: 'bulk-modal',
      templateUrl: '/views/modals/_bulk-messaging-modal-success.html',
      controller: 'BulkMessagingModalSuccessCtrl',
      size: 'sm',
      resolve: createResolve({
        status,
      }),
    }),

    clinicTutorial: {
      windowClass: 'clinic-tutorial',
      templateUrl: '/views/modals/_clinic-tutorial-modal.html',
      controller: 'ClinicTutorialModal',
      backdrop: 'static',
    },

    verifyAppointment: ({ appointmentId }) => ({
      windowClass: 'verify-appointment-modal',
      templateUrl: '/views/modals/_verify-appointment.html',
      controller: 'VerifyAppointmentModalCtrl',
      resolve: createResolve({
        appointmentId,
      }),
    }),

    disableAi: ({ clinicId }) => ({
      windowClass: 'disable-ai-modal',
      templateUrl: '/views/modals/_disable-ai.html',
      size: 'lg',
      controller: 'DisableAiModalCtrl',
      resolve: createResolve({ clinicId }),
    }),
  };

  const showCustomModal = (modalInfo) => {
    return $modal.open({
      ...modalInfo,
      windowClass: `modal fade in ${modalInfo.windowClass ?? ''}`,
    }).result;
  };

  return {
    showCustomModal,
    createResolve,

    showModal: (name, args) => {
      const modal = modals[name];
      if (!modal) {
        OCLogUtil.rollbar.error(`Tried to open model that doesn't exist: ${name}`);
        return new Promise.reject(`Modal '${name}' doesn't exist`);
      }

      const modalInfo = _.isFunction(modal) ? modal(args) : modal;
      return showCustomModal(modalInfo);
    },
  };
});
